import { DailyGoalValues } from '../types'
import { SubmittedUserWorking } from './submittedGoalConfig'

export interface SubmittedDailyGoal {
  date: string
  goal: number
  goalLocked: boolean
  users: Array<{ dayOff: { enable: boolean }; userId: string }>
  working: boolean
}

export const parseDailyGoalCents = (value: string): number => {
  const digits = value.replace(/\D/g, '')
  return digits ? Number(digits) : 0
}

export const getManualGoalTotals = (
  values: DailyGoalValues,
  storeIds: string[]
): Map<string, number> => new Map(storeIds.map(storeId => {
  const totalCents = Object.values(values).reduce(
    (total, dayValues) => total + parseDailyGoalCents(dayValues[storeId] || ''),
    0
  )
  return [storeId, totalCents / 100]
}))

export const buildManualDailyGoals = ({
  storeId,
  usersWorking,
  values
}: {
  storeId: string
  usersWorking: SubmittedUserWorking[]
  values: DailyGoalValues
}): SubmittedDailyGoal[] => {
  const activeUserIds = usersWorking.filter(user => user.active).map(user => user.userId)

  return Object.keys(values).sort().map(dayKey => {
    const goalCents = parseDailyGoalCents(values[dayKey]?.[storeId] || '')
    const working = goalCents > 0

    return {
      date: `${dayKey}T15:00:00.000Z`,
      goal: goalCents / 100,
      goalLocked: true,
      users: working
        ? activeUserIds.map(userId => ({ dayOff: { enable: false }, userId }))
        : [],
      working
    }
  })
}
